// import React from 'react'
// import { NavLink } from 'react-router-dom'
// import { SlHome } from 'react-icons/sl'
// import { BsWallet, BsGift } from 'react-icons/bs'
// import { FiUser, FiUsers } from 'react-icons/fi'
// import { AiOutlineMessage } from 'react-icons/ai'
// import { BiMessageSquareDetail } from 'react-icons/bi'

// const BottonMenu = ({ w3_close }) => {
//   return (
//     <div className="bottom_nav_wrapper">
//       <div className="bottom_nav_bar">

//         <NavLink exact to="/wallet" className="nav_item" activeClassName="active">
//           <img src="/wallet.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/refer" className="nav_item" activeClassName="active">
//           <img src="/bootom-refer.png" alt="" style={{marginRight:"60px"}} />
//         </NavLink>

//         {/* CENTER HOME BUTTON */}
//         <NavLink exact to="/landing" className="center_button" activeClassName="active_center">
//           <img src="/home.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/support" className="nav_item" activeClassName="active">
//           <img src="/customer-support.png" alt="" />
//         </NavLink>

//         <NavLink exact to="/Profile" className="nav_item" activeClassName="active">
//           <img src="/bootom_user.png" alt="" />
//         </NavLink>

//       </div>
//     </div>

//   )
// }

// export default BottonMenu
import React from 'react'
import { NavLink } from 'react-router-dom'
// Kept for consistency if you decide to use them later, though your code uses image tags
import { SlHome } from 'react-icons/sl'
import { BsWallet, BsGift } from 'react-icons/bs'
import { FiUser, FiUsers } from 'react-icons/fi'
import { AiOutlineMessage } from 'react-icons/ai'
import { BiMessageSquareDetail } from 'react-icons/bi'

const BottonMenu = ({ w3_close }) => {
  return (
    <>
      <style>
        {`
          .premium-bottom-wrapper {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            z-index: 9999;
           
          }

          .premium-bottom-nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: rgba(20, 25, 40, 0.85);
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 20px;
            padding: 5px 25px;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
            position: relative;
          }

          /* Standard Nav Items */
          .premium-nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            text-decoration: none;
            position: relative;
            padding: 5px;
            transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          }

          .premium-nav-item img {
            width: 24px;
            height: 24px;
            object-fit: contain;
            opacity: 0.5;
            transform: scale(0.9);
            transition: all 0.3s ease;
          }

          .premium-nav-item:hover img {
            opacity: 0.8;
            transform: translateY(-2px) scale(1.05);
          }

          /* Active State for Standard Items */
          .premium-nav-item.active img {
            opacity: 1;
            transform: translateY(-4px) scale(1.1);
            filter: drop-shadow(0px 4px 6px rgba(0, 255, 136, 0.4));
          }

          .premium-nav-item.active::after {
            content: '';
            position: absolute;
            bottom: -6px;
            width: 6px;
            height: 6px;
            background: #00ff88;
            border-radius: 50%;
            box-shadow: 0 0 10px #00ff88, 0 0 20px #00ff88;
            animation: popIn 0.3s ease forwards;
          }

          /* Center Floating Button Wrapper */
          .center-btn-wrapper {
            position: relative;
            top: -25px; /* Elevates the button above the bar */
            display: flex;
            justify-content: center;
            align-items: center;
          }

          /* Center Button Inner Styling */
          .premium-center-btn {
            background: linear-gradient(135deg, #f0c022 0%, #d4a71c 100%);
            width: 60px;
            height: 60px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 4px solid #0a0f1c; /* Creates a clean cutout effect against the dark bar */
            box-shadow: 0 8px 25px rgba(240, 192, 34, 0.4);
            transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            text-decoration: none;
            position: relative;
            z-index: 2;
          }

          .premium-center-btn img {
            width: 28px;
            height: 28px;
            object-fit: contain;
            filter: brightness(0); /* Turns the icon black for high contrast */
            transition: all 0.3s ease;
          }

          .premium-center-btn:hover, .premium-center-btn.active_center {
            transform: scale(1.1);
            box-shadow: 0 12px 30px rgba(240, 192, 34, 0.6);
          }

          .premium-center-btn.active_center img {
            transform: scale(1.1);
          }

          /* Pulsing Ring Animation behind the center button */
          .pulse-ring {
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(240, 192, 34, 0.4);
            border-radius: 50%;
            z-index: 1;
            animation: pulseGlow 2s infinite;
          }

          /* Keyframes */
          @keyframes popIn {
            0% { transform: scale(0); opacity: 0; }
            100% { transform: scale(1); opacity: 1; }
          }

          @keyframes pulseGlow {
            0% { transform: scale(1); opacity: 0.8; }
            70% { transform: scale(1.5); opacity: 0; }
            100% { transform: scale(1); opacity: 0; }
          }
        `}
      </style>

      <div className="premium-bottom-wrapper">
        <div className="premium-bottom-nav">

          {/* 1. Wallet */}
          <NavLink exact to="/wallet" className="premium-nav-item" activeClassName="active">
            <img src="/wallet.png" alt="Wallet" />
          </NavLink>

          {/* 2. Refer */}
          <NavLink exact to="/refer" className="premium-nav-item" activeClassName="active">
            <img src="/bootom-refer.png" alt="Refer" />
          </NavLink>

          {/* 3. CENTER HOME BUTTON */}
          <div className="center-btn-wrapper">
            <NavLink exact to="/landing" className="premium-center-btn" activeClassName="active_center">
              <div className="pulse-ring"></div>
              <img src="/home.png" alt="Home" />
            </NavLink>
          </div>

          {/* 4. Support */}
          <NavLink exact to="/support" className="premium-nav-item" activeClassName="active">
            <img src="/customer-support.png" alt="Support" />
          </NavLink>

          {/* 5. Profile */}
          <NavLink exact to="/Profile" className="premium-nav-item" activeClassName="active">
            <img src="/bootom_user.png" alt="Profile" />
          </NavLink>

        </div>
      </div>
    </>
  )
}

export default BottonMenu